import AccettazioneAbruzzo from "../";

const routes = [
    { name: "Elenco Accettazioni", path: "/accettazioneabruzzo", component: AccettazioneAbruzzo.AccettazioneAbruzzoList, meta: { title: "Elenco Accettazione" } },
    { name: "AccettazioniEdit", path: "/accettazioneabruzzo/edit/:id", component: AccettazioneAbruzzo.AccettazioneAbruzzoEdit, meta: { title: "Accettazione" } },
    { name: "AccettazioneAbruzzoView", path: "/accettazioneabruzzo/view/:id", component: AccettazioneAbruzzo.AccettazioneAbruzzoView, meta: { title: "Accettazione" } },
];

export default routes;
